import { render, staticRenderFns } from "./button-m.vue?vue&type=template&id=e42a0d12&scoped=true&"
import script from "./button-m.vue?vue&type=script&lang=js&"
export * from "./button-m.vue?vue&type=script&lang=js&"
import style0 from "./button-m.vue?vue&type=style&index=0&id=e42a0d12&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42a0d12",
  null
  
)

export default component.exports